import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { FaCloudUploadAlt, FaTimes } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { uploadAvatar, uploadCover } from '../../../../queries';

import { Content, DropContainer, DropContent } from './styles';

class Design extends Component {
  state = {
    avatar: null,
    cover: null,
  }

  componentDidMount = () => {
    const { avatarUrl, coverUrl } = this.props.store;

    if (avatarUrl) {
      const avatar = avatarUrl.replace(/.*?_/, '');

      this.setState({
        avatar: {
          name: avatar,
          uploaded: true,
          url: avatarUrl,
        },
      });
    }

    if (coverUrl) {
      const cover = coverUrl.replace(/.*?_/, '');

      this.setState({
        cover: {
          name: cover,
          uploaded: true,
          url: coverUrl,
        },
      });
    }
  }

  handleAvatarUpload = (file) => {
    this.setState({
      avatar: {
        name: file[0].name,
        progress: 0,
        uploaded: false,
        error: false,
        url: null,
      },
    });

    this.props
      .uploadAvatar({
        variables: {
          id: this.props.store.id,
          avatar: file[0],
        },
        context: {
          fetchOptions: {
            onUploadProgress: ((e) => {
              const progress = parseInt(Math.round((e.loaded * 100) / e.total));

              this.setState(prevState => ({
                avatar: {
                  ...prevState.avatar,
                  progress,
                },
              }));
            }),
          },
        },
      })
      .then(async (res) => {
        this.setState(prevState => ({
          avatar: {
            ...prevState.avatar,
            uploaded: true,
            url: res.data.uploadAvatarPortal.avatarUrl,
          },
        }));

        const stores = this.props.storesList;

        stores.forEach((store, i) => {
          if (store.id === this.props.store.id) {
            stores[i].avatarUrl = res.data.uploadAvatarPortal.avatarUrl;
            this.props.saveUser({ stores });
          }
        });

        this.props.saveStore({ avatarUrl: res.data.uploadAvatarPortal.avatarUrl });
        this.props.handleChangeState({ avatarUrl: res.data.uploadAvatarPortal.avatarUrl });
      })
      .catch(() => {
        this.setState({
          avatar: { error: true },
        });
      });
  }

  handleCoverUpload = (file) => {
    this.setState({
      cover: {
        name: file[0].name,
        progress: 0,
        uploaded: false,
        error: false,
        url: null,
      },
    });

    this.props
      .uploadCover({
        variables: {
          id: this.props.store.id,
          cover: file[0],
        },
        context: {
          fetchOptions: {
            onUploadProgress: ((e) => {
              const progress = parseInt(Math.round((e.loaded * 100) / e.total));

              this.setState(prevState => ({
                cover: {
                  ...prevState.cover,
                  progress,
                },
              }));
            }),
          },
        },
      })
      .then(async (res) => {
        this.setState(prevState => ({
          cover: {
            ...prevState.cover,
            uploaded: true,
            url: res.data.uploadCoverPortal.coverUrl,
          },
        }));

        this.props.saveStore({ coverUrl: res.data.uploadCoverPortal.coverUrl });
        this.props.handleChangeState({ coverUrl: res.data.uploadCoverPortal.coverUrl });
      })
      .catch(() => {
        this.setState({
          cover: { error: true },
        });
      });
  }

  deleteAvatar = () => {
    this.setState({ avatar: null });
  }

  deleteCover = () => {
    this.setState({ cover: null });
  }

  render() {
    const { avatar, cover } = this.state;

    return (
      <Content>
        <h2>Design</h2>
        <DropContainer>
          <div className="container">
            <p className="title">Logotipo</p>
            {(!avatar || avatar.error) && (
              <Dropzone
                accept={['image/png', 'image/jpeg']}
                multiple={false}
                maxSize={2000000}
                onDropAccepted={this.handleAvatarUpload}
              >
                {({
                  getRootProps, getInputProps, isDragActive, isDragReject,
                }) => (
                  <DropContent
                    {...getRootProps()}
                    isDragActive={isDragActive}
                    isDragReject={isDragReject || (avatar && avatar.error)}
                    cursor="pointer"
                  >
                    <FaCloudUploadAlt className="fa fa-cloud-upload-alt" />
                    <h3>Enviar logotipo</h3>
                    <div className="info">
                      <p>Tamanho máximo 2 MB</p>
                      <div className="format">
                        <span>JPG</span>
                        <span>PNG</span>
                      </div>
                    </div>
                    <input {...getInputProps()} />
                  </DropContent>
                )}
              </Dropzone>
            )}
            {avatar && !avatar.uploaded && !avatar.error && (
              <DropContent cursor="auto" isDragReject={avatar.error} progress={avatar.progress}>
                <FaCloudUploadAlt className="fa fa-cloud-upload-alt" />
                <h3>{avatar.name}</h3>
                <div className="progress">
                  <div className="progress-bar">
                    <div className="progress-bar-inside" />
                  </div>
                  <p>Realizando upload, aguarde...</p>
                </div>
              </DropContent>
            )}
            {avatar && avatar.uploaded && (
              <DropContent cursor="auto" isDragReject={avatar.error}>
                <img src={avatar.url} alt="" className="uploaded-avatar" />
                <div className="image-name">
                  <h3>{avatar.name}</h3>
                </div>
                <div className="buttons">
                  <button type="button" className="delete" onClick={this.deleteAvatar}>
                    <FaTimes className="fas fa-times" />
                    <span>Remover</span>
                  </button>
                </div>
              </DropContent>
            )}
          </div>
          <div className="container">
            <p className="title">Capa do perfil</p>
            {(!cover || cover.error) && (
              <Dropzone
                accept={['image/png', 'image/jpeg']}
                multiple={false}
                maxSize={2000000}
                onDropAccepted={this.handleCoverUpload}
              >
                {({
                  getRootProps, getInputProps, isDragActive, isDragReject,
                }) => (
                  <DropContent
                    {...getRootProps()}
                    isDragActive={isDragActive}
                    isDragReject={isDragReject || (cover && cover.error)}
                    cursor="pointer"
                  >
                    <FaCloudUploadAlt className="fa fa-cloud-upload-alt" />
                    <h3>Enviar capa do perfil</h3>
                    <div className="info">
                      <p>Tamanho máximo 2 MB</p>
                      <div className="format">
                        <span>JPG</span>
                        <span>PNG</span>
                      </div>
                    </div>
                    <input {...getInputProps()} />
                  </DropContent>
                )}
              </Dropzone>
            )}
            {cover && !cover.uploaded && !cover.error && (
            <DropContent cursor="auto">
              <FaCloudUploadAlt className="fa fa-cloud-upload-alt" />
              <h3>{cover.name}</h3>
              <div className="progress">
                <div className="progress-bar">
                  <div className="progress-bar-inside" />
                </div>
                <p>Realizando upload, aguarde...</p>
              </div>
            </DropContent>
            )}
            {cover && cover.uploaded && (
              <DropContent cursor="auto">
                <img src={cover.url} alt="" className="uploaded-cover" />
                <div className="image-name">
                  <h3>{cover.name}</h3>
                </div>
                <div className="buttons">
                  <button type="button" className="delete" onClick={this.deleteCover}>
                    <FaTimes className="fas fa-times" />
                    <span>Remover</span>
                  </button>
                </div>
              </DropContent>
            )}
          </div>
        </DropContainer>
      </Content>
    );
  }
}

export default compose(
  graphql(uploadAvatar, { name: 'uploadAvatar' }),
  graphql(uploadCover, { name: 'uploadCover' }),
)(Design);
